import * as API from 'aws-amplify/api';
import { ConsoleLogger as Logger } from 'aws-amplify/utils';
import { notification } from 'antd';
import { createErrorMessage } from './globalStateHelper';

const log = new Logger('context:invoices');

async function updateInvoices(start) {
  const {
    invoices: existingInvoices,
    isAdmin,
    isReadOnlyAdmin,
    selectedMarketPartyId,
  } = this.state;

  if (isAdmin() || isReadOnlyAdmin()) return;

  try {
    const { body } = await API.get({
      apiName: 'FINTSO',
      path: `/marketparties/${selectedMarketPartyId}/invoices`,
      options: {
        queryParams: {
          start,
        },
      },
    }).response;
    const { items: invoices } = await body.json();
    this.setState({
      invoices: {
        ...existingInvoices,
        [start]: invoices,
      },
    });
    log.info(`invoices for ${start} updated with data:`, invoices);
  } catch (error) {
    const { t } = this.props;
    notification.error({
      className: 'notification-error',
      message: t('common.notifications.errorFetchingInvoices'),
      description: await createErrorMessage(error),
    });
    log.error(`error fetching invoices for ${start}:`, await createErrorMessage(error, true));
  }
}

const invoicesContext = {
  invoices: {},
  updateInvoices: () => {},
};

const functions = {
  updateInvoices,
};

const invoices = {
  ...invoicesContext,
  ...functions,
};

export {
  invoicesContext,
  invoices,
};
